import { createReducer } from "@reduxjs/toolkit";
import {
  FETCH_REMINDERS_SUCCESS,
  ADD_REMINDER_SUCCESS,
  DELETE_REMINDER_SUCCESS,
  ADD_REMINDER_FROM_EVENT_STREAM,
  UPDATE_REMINDER_FROM_EVENT_STREAM,
  DELETE_REMINDER_FROM_EVENT_STREAM,
  EDIT_REMINDER_SUCCESS,
  FETCH_CALENDAR_ASSIGMENTS_SUCCESS,
} from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addMatcher(
      (action) => [DELETE_REMINDER_FROM_EVENT_STREAM, DELETE_REMINDER_SUCCESS].includes(action.type),
      (state, action) => {
        const { id } = action;
        if (id) {
          const { [id]: _deleted, ...rest } = state;
          return rest;
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [
          FETCH_REMINDERS_SUCCESS,
          ADD_REMINDER_FROM_EVENT_STREAM,
          UPDATE_REMINDER_FROM_EVENT_STREAM,
          ADD_REMINDER_SUCCESS,
          EDIT_REMINDER_SUCCESS,
          FETCH_CALENDAR_ASSIGMENTS_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { reminders } = entities;
        if (reminders) {
          return {
            ...state,
            ...reminders,
          };
        }
        return state;
      }
    );
});

export default reducer;
